export default "__VITE_ASSET__56a100ae__"